import { Form, Formik } from 'formik';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import useStyles from './FormModal.styles';
import Modal from './Modal';
import FormButtons from '../buttons/FormButtons';

const FormModal = ({ closeModal, formValues, validationSchema, onSubmitClick, onCancelClick, title, children }) => {
  const classes = useStyles();
  const handleSubmitClick = useCallback(
    (values) => {
      onSubmitClick(values);
      closeModal();
    },
    [closeModal, onSubmitClick]
  );

  const handleCancelClick = useCallback(() => {
    onCancelClick();
    closeModal();
  }, [closeModal, onCancelClick]);

  return (
    <Modal>
      <div className={classes.content}>
        <h2 className={classes.title}>{title}</h2>
        <Formik initialValues={formValues} onSubmit={handleSubmitClick} validationSchema={validationSchema}>
          {({ values, setFieldValue }) => (
            <Form className={classes.form}>
              {typeof children === 'function' ? children({ values, setFieldValue }) : children}
              <div className={classes.buttons}>
                <FormButtons submitLabel={i18n.t('common.button.confirm')} onCancel={handleCancelClick} />
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Modal>
  );
};

FormModal.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  closeModal: PropTypes.func.isRequired,
  validationSchema: PropTypes.shape(),
  formValues: PropTypes.shape().isRequired,
  onCancelClick: PropTypes.func.isRequired,
  onSubmitClick: PropTypes.func.isRequired,
  title: PropTypes.string,
};

FormModal.defaultProps = {
  children: undefined,
  validationSchema: undefined,
  title: undefined,
};

export default React.memo(FormModal);
